exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-cdb50bbc] .el-card__body{height:100%}[data-v-cdb50bbc] .el-table__body .el-table__row .cell{padding:10px 0;height:100px;overflow:scroll}", ""]);

// exports
